import React, {useContext, useEffect, useState} from 'react'

import {StorageContext} from '../../context'

import FavoriteContent from '../../favorite-content';
import Paginator from "../../paginator";
import BreadCrumbs from "../../bread-crumbs";

const Favorite = () => {
  const storage = useContext(StorageContext);

  const
    data = storage.getFavorites(),
    favoritesCount = data.length,
    pages = Math.ceil(favoritesCount / 12);

  const
    clientHeight = document.documentElement.clientHeight,
    headerHeight = 225,
    footerHeight = 355,
    wrapperHeight = clientHeight - headerHeight - footerHeight;

  const
    [currentPage, setCurrentPage] = useState(1),
    [contentParams, setContentParams] = useState(null),
    [favoriteClick, setFavoriteClick] = useState(false),
    [wrapperStyle, setWrapperStyle] = useState(
      favoritesCount === 0 && wrapperHeight > 75 ?
        {height: `${wrapperHeight}px`} :
        {}
    ),
    [sortBy, setSortBy] = useState('popularity');

  useEffect(() => {
    const data = storage.getFavorites();
    const currentPageData = data.splice((currentPage - 1) * 12, 12);

    if (currentPageData.length === 0 && currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }

    let newParams;

    if (currentPageData.length) {
      newParams = `id[]=${currentPageData.join('&id[]=')}&sortBy=${sortBy}`
    } else {
      newParams = null
    }

    setContentParams(newParams)
  }, [currentPage, favoriteClick, sortBy]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  useEffect(() => {
    if (favoritesCount === 0 && wrapperHeight > 75) {
      setWrapperStyle({height: `${wrapperHeight}px`})
    } else {
      setWrapperStyle({});
    }
  }, [favoritesCount, wrapperHeight]);

  const handleFavoriteClick = event => {
    event.preventDefault();

    if (event.target.classList.contains('product-catalogue__product_favorite-chosen')) {
      setFavoriteClick(!favoriteClick);
    }
  };

  return (
    <div className="wrapper wrapper_favorite" style={wrapperStyle}>
      <BreadCrumbs path={[{title: 'Избранное'}]}/>
      <main className="product-catalogue product-catalogue_favorite"
            onClick={handleFavoriteClick}>
        <FavoriteContent params={contentParams}
                         favoritesCount={favoritesCount}
                         currentPage={currentPage}
                         setCurrentPage={setCurrentPage}
                         sortBy={sortBy}
                         setSortBy={setSortBy}/>
        <div className="product-catalogue__pagination">
          <Paginator currentPage={currentPage}
                     pages={pages}
                     setCurrentPage={setCurrentPage}/>
        </div>
      </main>
    </div>
  )
};

export default Favorite
